import React from 'react';
import { H2, P, Code, Pre, Callout } from './_shared';

export default {
  slug: 'public-api',
  title: 'Public REST API',
  category: 'integrations',
  summary: 'A small, intentional REST surface at /v1/*. Browse the interactive playground at /v1/docs.',
  searchTerms: ['rest', 'api', 'v1', 'openapi', 'swagger', 'docs'],
  related: ['api-keys', 'webhooks'],
  Body: () => (
    <>
      <P>
        The public API at <Code>/v1/*</Code> is deliberately small. We don't
        mirror the full internal API because every endpoint we expose
        becomes a forever-supported public commitment. What's there is what
        90% of integrations need.
      </P>

      <H2>Docs</H2>
      <P>
        Interactive Swagger UI at <Code>https://api.realtyflows.com/v1/docs</Code>.
        Raw OpenAPI 3.1 spec at <Code>/v1/openapi.json</Code> — import that
        into Postman, code generators, or your IDE for autocomplete.
      </P>

      <H2>Endpoints today</H2>
      <Pre>{`GET    /v1/me
GET    /v1/clients              ?search=&status=&source=&limit=&offset=
POST   /v1/clients
GET    /v1/clients/{id}
GET    /v1/deals                ?status=&client_id=&limit=&offset=
POST   /v1/deals`}</Pre>

      <H2>Pagination</H2>
      <P>
        List endpoints accept <Code>limit</Code> (max 200, default 50) and{' '}
        <Code>offset</Code>. The response shape is{' '}
        <Code>{`{ data: [...], count: N }`}</Code>.
      </P>

      <H2>Errors</H2>
      <P>
        Standard HTTP status codes. Error bodies are{' '}
        <Code>{`{ error: "human-readable message" }`}</Code>. We don't
        return stack traces or internal details.
      </P>

      <Callout kind="info">
        Looking for something not listed? Webhooks plus the existing
        endpoints cover most workflows. If you need a specific endpoint
        added, email api@realtyflows.com with the use case.
      </Callout>
    </>
  ),
};
